
import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Trigger the fade-in animation after component mounts
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/3c0acd85b9d47fd01ee1f088ac5ad418.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-slate-900/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Logo and Company Name */}
          <div className={`flex items-center justify-center space-x-4 mb-8 group cursor-pointer transition-all duration-1000 ${
            isLoaded 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}>
            <div className="relative w-32 h-32">
              <img 
                src="https://static.readdy.ai/image/dadfa7b8e8bbab8ae3e8df395caac6f8/302de87561c96b1946ecbbc97f2148e3.png" 
                alt="ARK Construction Consultants Inc Logo"
                className="w-32 h-32 object-contain transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 via-orange-500/20 to-red-600/20 rounded-full scale-0 group-hover:scale-150 transition-all duration-500 blur-xl"></div>
            </div>

            <div className="text-left">
              <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 leading-tight">
                ARK CONSTRUCTION
              </h1>
              <p className="text-xl md:text-2xl text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 font-medium">
                CONSULTANTS INC™
              </p>
            </div>
          </div>

          <h2 className={`text-2xl md:text-3xl font-bold text-white mb-6 transition-all duration-1000 delay-200 ${
            isLoaded 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}>
            Building Foundations for Sovereign Futures
          </h2>
          
          <p className={`text-xl text-slate-300 mb-8 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 delay-400 ${
            isLoaded 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}>
            Global AI-ready, sustainable, affordable, and smart infrastructure development company. 
            Building homes, ports, hospitals, warehouses, and green cities worldwide.
          </p>

          <div className={`flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-1000 delay-600 ${
            isLoaded 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}>
            <Button onClick={scrollToContact} size="lg" className="min-w-[200px]">
              <i className="ri-phone-line mr-2"></i>
              Request Consultation
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              className="min-w-[200px]"
            >
              <i className="ri-arrow-down-line mr-2"></i>
              Learn More
            </Button>
          </div>

          {/* Egyptian Hieroglyphs */}
          <div className={`mt-12 flex justify-center space-x-4 text-3xl text-yellow-400/60 transition-all duration-1000 delay-800 ${
            isLoaded 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-10'
          }`}>
            <span>𓀀</span>
            <span>𓁐</span>
            <span>𓀭</span>
            <span>𓂀</span>
            <span>𓇳</span>
            <span>𓀠</span>
            <span>𓃀</span>
            <span>𓊖</span>
            <span>𓈖</span>
            <span>𓇯</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className={`absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce transition-all duration-1000 delay-1000 ${
        isLoaded 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-10'
      }`}>
        <div className="w-6 h-10 border-2 border-yellow-400 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-yellow-400 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
